<template>
  <div id="app">

    <div class="Page">
      <tab />
      <router-view v-if="!showWelcomePage" />
    </div>
    <div class="btn-content">
      <a
        href="https://buddy.edgeprop.sg/navagrove"
        target="_blank"
        rel="noopener noreferrer"
        ><img src="@/assets/btn/edgeprop-logo.png" alt="" /></a
      ><a
        href="https://www.facebook.com/profile.php?id=61561526866898"
        target="_blank"
        rel="noopener noreferrer"
        ><img src="@/assets/btn/Facebook.png" alt="" /></a
      ><a
        href="https://www.instagram.com/navagrove/"
        target="_blank"
        rel="noopener noreferrer"
        ><img src="@/assets/btn/Instagram.jpg" alt="" /></a
      ><a
        href="https://www.tiktok.com/@navagrove"
        target="_blank"
        rel="noopener noreferrer"
        ><img src="@/assets/btn/TikTok.jpg" alt=""
      /></a>
    </div>
    <div v-if="showWelcomePage" class="welcomePage flex-contents">
      <video
        playsinline=""
        autoplay="autoplay"
        muted="muted"
        src="@/assets/media/WelcomeVideo.mp4"
        style="min-width: 100%; position: absolute; min-height: 100%"
      ></video>
      <div class="gohome1" @click="showPage" style="animation: growFromOpacity 3s ease-out 3s forwards;opacity: 0;">FIND OUT MORE</div>
    </div>
  </div>
</template>

<script>

import tab from './components/tab.vue'

export default {
  components:{
    tab,
  },
  data() {
    return {
      showWelcomePage:true,
      timeout: null,
    };
  },
  methods: {
    showPage(){
      this.showWelcomePage = false;
      this.setupEventListeners(); // 设置事件监听器
      this.resetTimer()
      console.log(999);
    },
    activateScreensaver() {
      this.showWelcomePage = true; // 显示屏保
    },
    resetTimer() {
      clearTimeout(this.timeout);
      // this.showWelcomePage = false;
      this.timeout = setTimeout(this.activateScreensaver, 10 * 60 * 1000); // 10 分钟
    },
    setupEventListeners() {
        window.onload = this.resetTimer; // 页面加载时重置计时器
        document.onmousemove = this.resetTimer; // 鼠标移动时重置计时器
        document.onkeypress = this.resetTimer; // 键盘按键时重置计时器
        document.onclick = this.resetTimer; // 鼠标点击时重置计时器
        document.onscroll = this.resetTimer; // 页面滚动时重置计时器
    }
  },
  mounted() {
      // this.setupEventListeners(); // 设置事件监听器
      // this.resetTimer()
    
  },
};
</script>

<style lang="less">
.btn-content {
  position: absolute;
  z-index: 120;
  right: 10px;
  bottom: 10%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  img {
    // width: 35px;
    height: 35px;
    display: block;
    margin: 5px;
    border-radius: 10px;
    // box-shadow: 0 5px 5px 3px #00000080;
    // background-color: white;
  }
}

.welcomePage {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #62828c;
  flex-direction: column;
  // justify-content: space-between !important;
  z-index: 999;

  .welcomePageImg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    // height: 100%;
    // object-fit: cover;
  }
  .gohome1 {
    position: absolute;
    bottom: 5%;
    cursor: pointer;
    padding: 20px;
    // width: 200px;
    font-size: 1rem;
    font-weight: 600;
    background-color: #9b6432;
    color: #fff;
    border-radius: 85px;
    animation: growFromScale 1s ease-out forwards;
    // animation-delay: 1s; /* 设置延迟时间为 .5s */
  }
}

html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  // background: linear-gradient(to right, #6c9eae, #928dab);
  background-color: #62828c;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

// 滚动条样式
* {
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color: #ffff;
    border-radius: 6px;
  }
  ::-webkit-scrollbar:hover {
    width: 10px !important;
  }
  ::-webkit-scrollbar-track {
    // width: 1px;
    background-color: #dfe3e400;
  }
  ::-webkit-scrollbar-thumb {
    // width: 1px;
    padding: 10px;
    border-radius: 6px;
    // height: 120px;
    background-color: rgb(83, 83, 83);
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: rgb(83, 83, 83);
    width: 30px !important;
  }
  ::-webkit-scrollbar-thumb:active {
    background-color: rgb(83, 83, 83);
  }

  .ai-pop-win {
    position: fixed;
    width: 500px;
    height: 60%;
    top: 20%;
    left: 50px;
    z-index: 1200;
    background-color: black;
  }
  .ai-pop-close {
    background-color: black;
    color: white;
    border: 0;
    padding: 10px;
    border-radius: 20px;
  }
}

@media screen and (max-height: 500px) {
  .ai-pop-win {
    width: 500px;
    height: 80% !important;
    top: 2% !important;
    left: 50px;
    z-index: 1200;
    background-color: black;
  }
  .ai-pop-close {
    padding: 5px !important;
  }
  .gohome1 {
    font-size: 2vw !important;
    margin: 10px !important;
    padding: 5px !important;
    color: white !important;
  }
}
</style>
